import { SwitchPropertiesType } from "@website/ui/switch/switch.types";
import pick from "lodash-es/pick";

export const useSwitch = (properties: SwitchPropertiesType) => ({
  inputProps: {
    ...pick(
      properties,
      "autoFocus",
      "disabled",
      "checked",
      "name",
      "onChange",
      "readOnly",
      "value",
      "aria-labelledby"
    ),
    role: "switch",
    type: "checkbox"
  }
});
